/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import 'assets/fontawesome';
import 'assets/styles/global.scss';
import { ViewMounter } from 'components/view_mounter';
import MessagesComponent from 'components/shared/overlay/messages';
import WaitComponent from 'components/shared/overlay/wait';
import { SecureRoute } from 'components/shared/secure_route';
import { FooterComponent } from 'components/shared/site/footer';
import { HeaderComponent } from 'components/shared/site/header';
import Main from 'components/shared/site/main';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, withRouter } from 'react-router-dom';
import { Panel, PanelPresets, UserPermissionsIds } from 'utility/enumerations';
import history from 'utility/history';
import { preloadView } from 'utility/preload';
import { mediaQueries } from 'utility/constants';
import HandleSessionTimeout from 'components/shared/site/session_timeout';
import { BreakpointProvider } from 'components/shared/context/breakpoint_provider';
import UserContainerScreen from 'components/user/user_container';
import PeopleSearchContainerScreen from 'components/search/people_search_container';
import ReportContainerScreen from 'components/reports/report_container';
import TransporterContainerScreen from 'components/transporter/transporter_container';
import ApplicationsContainerScreen from 'components/applications/applications_container';
import DashboardContainerScreen from 'components/dashboard/dashboard_container';
import MfaContainerScreen from 'components/security/mfa/mfa_container';
import PatientContainerScreen from 'components/patient/patient_container';
import CaregiverContainerScreen from 'components/caregiver/caregiver_container';
import PhysicianContainerScreen from 'components/physician/physician_container';
import QualifyingDocContainerScreen from 'components/caregiver/qualifying_doc/qualifying_doc_container';
import AdminCertDocsContainerScreen from 'components/physician/certification_documentation/cert_docs_container';
import MQACheckContainerScreen from 'components/physician/mqa/mqa_check_container';
import SuspensionsContainerScreen from 'components/suspensions/suspensions_container';
import SystemManagementContainerScreen from 'components/system/system_management_container';
import ToolsContainer from 'components/admin/tools/tools_container';
import HsmvDemoCheck from 'components/tools/hsmv_demo_check';
import HsmvPhotoCheck from 'components/tools/hsmv_check_photo';
import { unAuthenticateUser, getCurrentUser } from 'redux/actions/security';
import { resetState, setPostLoginRoute, setPrimaryPanelComponents } from 'redux/actions/global';
import Panels from 'components/shared/site/panels';
import { getPostLoginRoute } from 'utility/helpers';

interface AppProps {
  debugOverlayEnabled: boolean,
  authenticated: boolean,
  location: any,
  getCurrentUser: () => Promise<any>,
  setPostLoginRoute: any
}

export const App = (props: AppProps) => {
  useEffect(() => {
    preloadView('search/people_search');
    if (props.authenticated) {
      props
        .getCurrentUser()
        .then()
        .catch(() => { });
    } else if (!props.location.pathname.includes('change-password')) {
      // to redirect to the first accessed route post login
      props.setPostLoginRoute(getPostLoginRoute(props.location?.pathname));
    }
  }, []);

  return (
    <div className="app" id="app">
      <BreakpointProvider queries={mediaQueries}>
        <Router history={history} basename="/spa">
          <Route
            path="/login"
            render={(props) => ViewMounter(props, {
              viewPath: 'security/login',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
          />
          <Route
            path="/login/sso"
            render={(props) => ViewMounter(props, {
              viewPath: 'security/login',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: { ssoEnabled: true },
              focusView: false,
              overrideLocation: '',
              params: { ssoEnabled: true }
            })}
          />
          <Route
            path="/forgot_password"
            render={(props) => ViewMounter(props, {
              viewPath: 'security/forgot_password',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
          />
          {' '}
          <Route
            path="/register"
            render={(props) => ViewMounter(props, {
              viewPath: 'security/register',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
          />
          <Route
            path="/sandbox"
            render={(props) => ViewMounter(props, [
              {
                viewPath: 'debug/sandbox',
                targetPanel: Panel.Primary,
                viewProps: { widget: 'A' },
                panelLayout: undefined,
                clear: undefined,
                focusView: false,
                overrideLocation: '',
                params: undefined
              },
              {
                viewPath: 'debug/sandbox',
                targetPanel: Panel.Secondary,
                panelLayout: PanelPresets.OneThirdTwoThird,
                viewProps: { widget: 'B' },
                clear: undefined,
                focusView: false,
                overrideLocation: '',
                params: undefined
              },
            ])}
          />
          <Route
            path="/vars"
            render={(props) => ViewMounter(props, {
              viewPath: 'debug/variables',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
          />
          <SecureRoute
            path="/application/:appType/:id"
            pathPermissionId={undefined}
            exact
            render={(props) => ViewMounter(props, {
              viewPath: 'applications/application/application',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            component={undefined}
          />
          <SecureRoute
            path="/admin/my-patients"
            pathPermissionId={UserPermissionsIds.AccessMyPatientsAll}
            exact
            render={(props) => ViewMounter(props, {
              viewPath: 'physician/my_patients/my_patients',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            component={undefined}
          />
          <SecureRoute
            path="/application/:appType/side_by_side/:id/:from"
            pathPermissionId={undefined}
            exact
            render={(props) => ViewMounter(props, {
              viewPath: 'applications/hsmv/side_by_side',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            component={undefined}
          />
          <SecureRoute
            path="/application/view/:appType/:id" // Admin -> View Application
            pathPermissionId={UserPermissionsIds.AdminReadApplications}
            exact
            render={(props) => ViewMounter(props, {
              viewPath: 'applications/application/application',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: { isView: true },
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            allowAnonymous={undefined}
            component={undefined}
          />
          <SecureRoute
            path="/application/supply/:appType/:id" // Admin -> Supply Application
            pathPermissionId={UserPermissionsIds.AdminSupplyApplications}
            exact
            render={(props) => ViewMounter(props, {
              viewPath: 'applications/application/application',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: { isSupply: true, isReview: false },
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            allowAnonymous={undefined}
            component={undefined}
          />
          <SecureRoute
            path="/application/review/:appType/:id" // Admin -> Review Application
            pathPermissionId={UserPermissionsIds.AdminReadApplications}
            exact
            render={(props) => ViewMounter(props, {
              viewPath: 'applications/application/application',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: { isReview: true, isSupply: false },
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            allowAnonymous={undefined}
            component={undefined}
          />
          {/* START - My Applications Route for Patients/Caregivers */}
          <SecureRoute
            path="/my-applications/:appType" // Card Applicant -> My Applications Dashboard
            pathPermissionId={UserPermissionsIds.ReadPatientApplication}
            render={(props) => ViewMounter(props, {
              viewPath: 'applications/my_applications',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              viewProps: undefined,
              focusView: false,
              clear: false,
              overrideLocation: '',
              params: undefined
            })}
            allowAnonymous={false}
            component={undefined}
          />
          <SecureRoute
            path="/my-applications/update-contact-info/:appType/:applicantId" // Card Applicant -> Update Contact Info
            pathPermissionId={UserPermissionsIds.ManageYourInformation}
            render={(props) => ViewMounter(props, {
              viewPath: 'applications/update_contact_info',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              viewProps: undefined,
              focusView: false,
              clear: false,
              overrideLocation: '',
              params: undefined
            })}
            allowAnonymous={undefined}
            component={undefined}
          />
          {/* END - My Applications Route for Patients/Caregivers */}
          <SecureRoute
            path="/correct-dispensations"
            pathPermissionId={UserPermissionsIds.AccessCorrectDispensations}
            allowAnonymous
            exact
            render={(props) => ViewMounter(props, {
              viewPath: 'corrections/correctdispensations',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            component={undefined}
          />
          <SecureRoute
            path="/suspension"
            pathPermissionId={undefined}
            component={SuspensionsContainerScreen}
            exact={undefined}
            allowAnonymous={undefined}
            render={undefined}
          />
          <SecureRoute
            path="/patient"
            pathPermissionId={undefined}
            component={PatientContainerScreen}
            exact={undefined}
            allowAnonymous={undefined}
            render={undefined}
          />
          <SecureRoute
            path="/transporters"
            pathPermissionId={UserPermissionsIds.AccessTransporters}
            component={TransporterContainerScreen}
            exact={undefined}
            allowAnonymous={undefined}
            render={undefined}
          />
          <SecureRoute
            path="/tools"
            pathPermissionId={undefined}
            component={ToolsContainer}
            exact={undefined}
            allowAnonymous={undefined}
            render={undefined}
          />
          <SecureRoute
            path="/physician"
            pathPermissionId={undefined}
            component={PhysicianContainerScreen}
            exact={undefined}
            allowAnonymous={undefined}
            render={undefined}
          />
          <SecureRoute
            path="/certification-documentation"
            pathPermissionId={UserPermissionsIds.AccessCertificationDocAll}
            component={AdminCertDocsContainerScreen}
            exact={undefined}
            allowAnonymous={undefined}
            render={undefined}
          />
          <SecureRoute
            path="/physician/mqa-check"
            pathPermissionId={UserPermissionsIds.AccessApiToolsMqa}
            component={MQACheckContainerScreen}
            exact={undefined}
            allowAnonymous={undefined}
            render={undefined}
          />
          <SecureRoute
            path="/tools/hsmv-demo-check"
            pathPermissionId={UserPermissionsIds.AccessApiToolsHsmvDemo}
            exact
            render={(props) => ViewMounter(props, {
              viewPath: 'tools/hsmv_demo_check.tsx',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              overrideLocation: undefined,
              focusView: undefined,
              params: undefined
            })}
            allowAnonymous={undefined}
            component={HsmvDemoCheck}
          />
          <SecureRoute
            path="/tools/hsmv-check-photo"
            pathPermissionId={UserPermissionsIds.AccessApiToolsHsmvPhoto}
            exact
            render={(props) => ViewMounter(props, {
              viewPath: 'tools/hsmv_check_photo.tsx',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              overrideLocation: undefined,
              focusView: undefined,
              params: undefined
            })}
            allowAnonymous={undefined}
            component={HsmvPhotoCheck}
          />
          <SecureRoute
            path="/physician/unclosed-certifications"
            pathPermissionId={UserPermissionsIds.ManageUnclosedOrUnsignedCertifications}
            render={(props) => ViewMounter(props, {
              viewPath: 'physician/patient_management/unclosed_certifications',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            exact={undefined}
          />
          <SecureRoute
            path="/physician/unclosed-certifications-dashboard/:fromDashboard"
            pathPermissionId={UserPermissionsIds.ManageUnclosedOrUnsignedCertifications}
            render={(props) => ViewMounter(props, {
              viewPath: 'physician/patient_management/unclosed_certifications',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            exact={undefined}
          />
          <SecureRoute
            path="/transporter/transporterdetails/:id"
            render={(props) => ViewMounter(props, {
              viewPath: 'transporter/transporter_details',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            exact={undefined}
          />
          <Route
            path="/interstitial"
            render={(props) => ViewMounter(props, {
              viewPath: 'security/interstitial',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            exact={undefined}
            allowAnonymous={undefined}
            component={undefined}
          />
          <SecureRoute
            path="/authorization"
            pathPermissionId={undefined}
            render={(props) => ViewMounter(props, {
              viewPath: 'security/initial_authorization',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            exact={undefined}
            allowAnonymous={undefined}
            component={undefined}
          />
          <SecureRoute
            path="/"
            pathPermissionId={undefined}
            allowAnonymous
            exact
            render={(props) => ViewMounter(props, {
              viewPath: 'public/home',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            component={undefined}
          />
          <SecureRoute
            path="/my-deliveries"
            pathPermissionId={UserPermissionsIds.MyDeliveries}
            allowAnonymous
            exact
            render={(props) => ViewMounter(props, {
              viewPath: 'dispenser/deliveries/my_deliveries',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            component={undefined}
          />
          <Route
            path="/accessibility"
            render={(props) => ViewMounter(props, {
              viewPath: 'shared/site/accessibility_policy',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
          />
          <Route
            path="/privacy"
            render={(props) => ViewMounter(props, {
              viewPath: 'shared/site/privacy_policy',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
          />
          <SecureRoute
            path="/my-profile"
            pathPermissionId={UserPermissionsIds.MyProfile}
            render={(props) => ViewMounter(props, {
              viewPath: 'user/my_profile',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            exact={undefined}
            allowAnonymous={undefined}
            component={undefined}
          />
          <SecureRoute
            path="/change-password"
            pathPermissionId={UserPermissionsIds.ChangePassword}
            render={(props) => ViewMounter(props, {
              viewPath: 'user/change_password',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            exact={undefined}
            allowAnonymous
            component={undefined}
          />
          <SecureRoute
            path="/user"
            pathPermissionId={undefined}
            component={UserContainerScreen}
            exact={undefined}
            allowAnonymous={undefined}
            render={undefined}
          />
          <SecureRoute
            path="/new-user-applicants"
            pathPermissionId={UserPermissionsIds.AccessNewApplicant}
            render={(props) => ViewMounter(props, {
              viewPath: 'user/grid/newuserapplicants/new_user_applicants',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            exact={undefined}
            allowAnonymous={undefined}
            component={undefined}
          />
          <SecureRoute
            path="/new-user-applicants-admin"
            pathPermissionId={UserPermissionsIds.AccessNewApplicant}
            render={(props) => ViewMounter(props, {
              viewPath: 'user/grid/newuserapplicants/new_user_applicants',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            exact={undefined}
            allowAnonymous={undefined}
            component={undefined}
          />
          <SecureRoute
            path="/people"
            pathPermissionId={UserPermissionsIds.PeopleSearch}
            component={PeopleSearchContainerScreen}
            exact={undefined}
            allowAnonymous={undefined}
            render={undefined}
          />
          <SecureRoute
            path="/deliveries"
            pathPermissionId={UserPermissionsIds.Deliveries}
            render={(props) => ViewMounter(props, {
              viewPath: 'dispenser/deliveries/deliveries',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            component={undefined}
            exact={undefined}
            allowAnonymous={undefined}
          />
          <SecureRoute
            path="/reports"
            pathPermissionId={UserPermissionsIds.AccessReports}
            component={ReportContainerScreen}
            exact={undefined}
            allowAnonymous={undefined}
          />
          <SecureRoute
            path="/reports/download/:fileId"
            pathPermissionId={UserPermissionsIds.AccessReports}
            render={(props) => ViewMounter(props, {
              viewPath: 'reports/report_download',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: undefined,
              params: undefined
            })}
            component={undefined}
            exact={undefined}
            allowAnonymous={false}
          />
          <SecureRoute
            path="/training"
            pathPermissionId={UserPermissionsIds.AccessTraining}
            exact
            render={(props) => ViewMounter(props, {
              viewPath: 'training/training',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              viewProps: undefined,
              focusView: false,
              clear: false,
              overrideLocation: '',
              params: undefined
            })}
            allowAnonymous={undefined}
            component={undefined}
          />
          <SecureRoute
            path="/applications"
            pathPermissionId={undefined}
            component={ApplicationsContainerScreen}
            exact={undefined}
            allowAnonymous={undefined}
            render={undefined}
          />
          <SecureRoute
            path="/caregiver"
            pathPermissionId={undefined}
            component={CaregiverContainerScreen}
            exact={undefined}
            allowAnonymous={undefined}
            render={undefined}
          />
          <SecureRoute
            path="/qualifying-documentation"
            pathPermissionId={undefined}
            component={QualifyingDocContainerScreen}
            exact={undefined}
            allowAnonymous={undefined}
            render={undefined}
          />
          <SecureRoute
            path="/dashboard"
            pathPermissionId={undefined}
            component={DashboardContainerScreen}
            exact={undefined}
            allowAnonymous={undefined}
            render={undefined}
          />
          <SecureRoute
            path="/mfa"
            pathPermissionId={undefined}
            component={MfaContainerScreen}
            exact={undefined}
            allowAnonymous={undefined}
            render={undefined}
          />
          <SecureRoute
            path="/logout"
            pathPermissionId={undefined}
            render={(props) => ViewMounter(props, {
              viewPath: 'security/logout',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              clear: true,
              viewProps: undefined,
              focusView: false,
              overrideLocation: '',
              params: undefined
            })}
            exact={undefined}
            allowAnonymous={undefined}
            component={undefined}
          />
          <SecureRoute
            path="/system"
            pathPermissionId={UserPermissionsIds.SystemManagement}
            component={SystemManagementContainerScreen}
            exact={undefined}
            allowAnonymous={undefined}
            render={undefined}
          />
          <HeaderComponent />
          {props.authenticated && (
            <HandleSessionTimeout />
          )}
          <Main className={props.debugOverlayEnabled ? 'debug-overlay' : null}>
            <WaitComponent />
            <MessagesComponent />
            <Panels />
          </Main>
          <FooterComponent />
        </Router>
      </BreakpointProvider>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    authenticated: state.security.authenticated,
    debugOverlayEnabled: state.global.debugOverlayEnabled,
  };
}

const mapDispatchToProps = {
  resetState,
  unAuthenticateUser,
  setPrimaryPanelComponents,
  getCurrentUser,
  setPostLoginRoute
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));

/* if (process.env.NODE_ENV !== 'production') {
  axe(React, ReactDOM, 1000, {});
} */
